// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EksterniLink_container__RDEH5 {
  gap: 24px;
  width: 100%;
  padding-top: 24px;
  padding-bottom: 24px;
}
.EksterniLink_logo__hO4T0 {
  width: 278px;
  height: 51px;
}
.EksterniLink_title__YV7pa {
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  margin: 16px;
  color: #4d4d4d;
}
.EksterniLink_column__d5fR7 {
  gap: 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #828d9a;
}
.EksterniLink_column__d5fR7,
.EksterniLink_title__YV7pa {
  font-family: Inter;
  letter-spacing: -0.001em;
  text-align: center;
}
.EksterniLink_wrapper__mz9ml {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-top: -140px;
  width: 50%;
}
.EksterniLink_imageContainer__8Y2WE {
  gap: 24px;
  background-color: #ebe6dd;
  height: 215px;
  margin-bottom: 64px;
  border-radius: 8px;
  border: 8px solid #ffffff;
}
.EksterniLink_imageUploadBtn__Sh5wd {
  height: 215px;
  width: 180px;
  border-radius: 8px;
  object-fit: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  border: none;
}
.EksterniLink_imageUploadBtn__Sh5wd:hover {
  cursor: pointer;
}
.EksterniLink_profileFormButtons__8-Ott {
  column-gap: 16px;
  display: flex;
  justify-content: center;
  margin-top: 34px;
  width: 100%;
}
.EksterniLink_closeButton__FnIfJ {
  background-color: #ebebeb;
}
.EksterniLink_closeButton__FnIfJ,
.EksterniLink_saveButton__c7\\+cI,
.EksterniLink_disabledBtn__TYROl {
  border-radius: 4px;
  cursor: pointer;
  height: 52px;
  width: 200px;
  transition: 300ms ease-in-out;
  border: none;
}
.EksterniLink_disabledBtn__TYROl {
  cursor: not-allowed;
  background-color: #caba92;
}
.EksterniLink_closeButtonText__7Lc68 {
  color: #808080;
}
.EksterniLink_saveButton__c7\\+cI {
  background-color: #cb9c2d;
}
.EksterniLink_closeButton__FnIfJ:hover {
  background-color: #cfcdcd;
}
.EksterniLink_saveButton__c7\\+cI:hover {
  background-color: #b38929;
}
.EksterniLink_closeButtonText__7Lc68,
.EksterniLink_saveButtonText__kIwwm {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.EksterniLink_saveButtonText__kIwwm {
  color: #ffffff;
}
.EksterniLink_imageUploadBtn__Sh5wd,
.EksterniLink_saveButton__c7\\+cI,
.EksterniLink_column__d5fR7,
.EksterniLink_closeButton__FnIfJ,
.EksterniLink_imageContainer__8Y2WE,
.EksterniLink_container__RDEH5 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.EksterniLink_column__d5fR7,
.EksterniLink_imageContainer__8Y2WE,
.EksterniLink_wrapper__mz9ml,
.EksterniLink_container__RDEH5 {
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/PrijavaNaEksterniLink/EksterniLink.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;;;;;;EAME,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;EAIE,sBAAsB;AACxB","sourcesContent":[".container {\n  gap: 24px;\n  width: 100%;\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n.logo {\n  width: 278px;\n  height: 51px;\n}\n.title {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  margin: 16px;\n  color: #4d4d4d;\n}\n.column {\n  gap: 16px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  color: #828d9a;\n}\n.column,\n.title {\n  font-family: Inter;\n  letter-spacing: -0.001em;\n  text-align: center;\n}\n.wrapper {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  margin-top: -140px;\n  width: 50%;\n}\n.imageContainer {\n  gap: 24px;\n  background-color: #ebe6dd;\n  height: 215px;\n  margin-bottom: 64px;\n  border-radius: 8px;\n  border: 8px solid #ffffff;\n}\n.imageUploadBtn {\n  height: 215px;\n  width: 180px;\n  border-radius: 8px;\n  object-fit: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n  border: none;\n}\n.imageUploadBtn:hover {\n  cursor: pointer;\n}\n.profileFormButtons {\n  column-gap: 16px;\n  display: flex;\n  justify-content: center;\n  margin-top: 34px;\n  width: 100%;\n}\n.closeButton {\n  background-color: #ebebeb;\n}\n.closeButton,\n.saveButton,\n.disabledBtn {\n  border-radius: 4px;\n  cursor: pointer;\n  height: 52px;\n  width: 200px;\n  transition: 300ms ease-in-out;\n  border: none;\n}\n.disabledBtn {\n  cursor: not-allowed;\n  background-color: #caba92;\n}\n.closeButtonText {\n  color: #808080;\n}\n.saveButton {\n  background-color: #cb9c2d;\n}\n.closeButton:hover {\n  background-color: #cfcdcd;\n}\n.saveButton:hover {\n  background-color: #b38929;\n}\n.closeButtonText,\n.saveButtonText {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.saveButtonText {\n  color: #ffffff;\n}\n.imageUploadBtn,\n.saveButton,\n.column,\n.closeButton,\n.imageContainer,\n.container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.column,\n.imageContainer,\n.wrapper,\n.container {\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EksterniLink_container__RDEH5`,
	"logo": `EksterniLink_logo__hO4T0`,
	"title": `EksterniLink_title__YV7pa`,
	"column": `EksterniLink_column__d5fR7`,
	"wrapper": `EksterniLink_wrapper__mz9ml`,
	"imageContainer": `EksterniLink_imageContainer__8Y2WE`,
	"imageUploadBtn": `EksterniLink_imageUploadBtn__Sh5wd`,
	"profileFormButtons": `EksterniLink_profileFormButtons__8-Ott`,
	"closeButton": `EksterniLink_closeButton__FnIfJ`,
	"saveButton": `EksterniLink_saveButton__c7+cI`,
	"disabledBtn": `EksterniLink_disabledBtn__TYROl`,
	"closeButtonText": `EksterniLink_closeButtonText__7Lc68`,
	"saveButtonText": `EksterniLink_saveButtonText__kIwwm`
};
export default ___CSS_LOADER_EXPORT___;
